import logoVideo from "../asset/Home/AI_LOGO.mp4";
import instagram from "../asset/Home/instagram.svg";
import twitter from "../asset/Home/twitter.svg";
import linkedin from "../asset/Home/linkedIn.svg";
// import footerText from "../asset/Home/footerText.svg";
import footerwaveLines from "../asset/Home/footerwaveLines.svg";
import footerWave from "../asset/Home/footerWawe.svg";
import demoRedCircle from "../asset/Home/demoRedCircle.svg";
import { motion } from "framer-motion";
// const tags = [
//   { left: "1%", bottom: "1%", rotate: -0 },
//   { left: "6%", bottom: "-2%", rotate: 18 },
//   { left: "12%", bottom: "1%", rotate: 40 },
//   { left: "19%", bottom: "1%", rotate: -0 },
//   { left: "24%", bottom: "-2%", rotate: 18 },

//   { left: "67%", bottom: "1%", rotate: -0 },
//   { left: "73%", bottom: "-2%", rotate: 18 },
//   { left: "78%", bottom: "2%", rotate: 40 },
//   { left: "85%", bottom: "1%", rotate: -28 },
//   { left: "90%", bottom: "-2%", rotate: 18 },
// ];
const tags = [
  { text: "AI Agents", left: "3%", bottom: "1%", rotate: -4 },
  { text: "50+ Languages", left: "7%", bottom: "3%", rotate: 31 },
  { text: "No-Code Builder", left: "15%", bottom: "1%", rotate: -20 },
  { text: "Workflow Automation", left: "21.7%", bottom: "0%", rotate: -0 },
  {
    text: "<200ms Latency",
    left: "27.5%",
    bottom: "7%",
    rotate: -40,
    hideOnMobile: true,
  },

  { text: "Real-Time Responses", left: "65%", bottom: "2%", rotate: 35 },
  { text: "24/7 Availability", left: "74%", bottom: "5%", rotate: -45 },
  { text: "Enterprise Security", left: "80%", bottom: "1%", rotate: 8 },
  { text: "Objection Handling", left: "85%", bottom: "4%", rotate: 30 },
  {
    text: "speech-to-text",
    left: "93%",
    bottom: "0%",
    rotate: 2,
    hideOnMobile: true,
  },
];
function Footer() {
  return (
    <footer
      id="contact"
      className="
    relative
    px-4
    sm:px-6
    pt-5
    lg:pb-6
	md:pb-5
	pb-3
    overflow-hidden
  "
      style={{ zoom: "0.95" }}
    >
      <div
        className="
    relative
    overflow-hidden

    max-w-[1400px]
    mx-auto

    bg-[#37342F]

    lg:rounded-[18px]
	md:rounded-[16px]
rounded-[12px]
    min-h-[380px]
    sm:min-h-[620px]
    lg:min-h-[700px]

    px-4
    sm:px-6
    lg:px-6

    pt-5
    sm:pt-10

    pb-[30px]
    sm:pb-[50px]
    lg:pb-[70px]
  "
      >
        {/* LEFT WAVE LINES */}
        <img
          src={footerwaveLines}
          alt=""
          className="
            absolute
            left-0
            top-0

            h-full

            opacity-30

            pointer-events-none
            select-none

            z-0
          "
        />

        {/* RIGHT WAVE LINES */}
        <img
          src={footerwaveLines}
          alt=""
          className="
            absolute
            right-0
            top-0

            h-full

            scale-x-[-1]

            opacity-30

            pointer-events-none
            select-none

            z-0
          "
        />

        {/* RED CIRCLE TOP RIGHT */}
        <img
          src={demoRedCircle}
          alt=""
          className="
            absolute

            top-[-550px]
            right-[-180px]

            w-[500px]
            lg:w-[700px]

            opacity-60

            pointer-events-none
            select-none

            z-0
          "
        />

        {/* HEADING */}
        <h2
          className="
            relative
            z-20

            text-center

            font-unbounded
            font-bold

            text-white

          text-[20px]
			md:text-[55px]
			lg:text-[100px]

            leading-none
          "
        >
          CRAFT YOUR AGENT
        </h2>

        {/* MAIN CONTENT */}
        <div
          className="
    relative
    z-20

    mt-6
    sm:mt-16

    pb-[50px]
    sm:pb-[80px]
    lg:pb-[120px]

    flex
            flex-col
            lg:flex-row

            justify-between
            items-start
          "
        >
          {/* LEFT SIDE */}
          <div
            className="
    flex
    flex-col

   items-center
lg:items-start
md:mt-[-30px]

    w-full
    lg:w-auto
  "
          >
            <img
              src={footerWave}
              alt=""
              className="
              w-[60px]
sm:w-[110px]
md:w-[90px]
lg:w-[138px]

mx-auto
sm:mx-0

sm:ml-4
lg:ml-8


              "
            />

            <div
              className="
  mt-4
  sm:mt-10
  lg:mt-12

  flex
items-center
lg:items-start
  justify-center

  w-full
  sm:w-auto

  gap-2
  sm:gap-4

  mx-auto
  sm:mx-0

  sm:ml-4
  lg:ml-10
"
            >
              <a
                href="#"
                className="
            w-6
            h-6
            sm:w-10
            sm:h-10
            md:h-8
            md:w-8
            rounded-md
                  flex
                  items-center
                  justify-center
                  hover:bg-[#E8604A]
                  transition-all
                  duration-300
                "
              >
                <img
                  src={instagram}
                  alt="Instagram"
                  className="w-6
h-6
sm:w-10
sm:h-10"
                />
              </a>

              <a
                href="#"
                className="
                        w-6
                      h-6
                      sm:w-10
                      sm:h-
                      md:h-8
                      md:w-8
                      rounded-md
                      flex
                        items-center
                        justify-center

                        hover:bg-[#E8604A]
                        transition-all
                        duration-300
                        "
              >
                <img
                  src={twitter}
                  alt="Twitter"
                  className="w-6
h-6
sm:w-10
sm:h-10"
                />
              </a>

              <a
                href="#"
                className="
w-6
h-6
sm:w-10
sm:h-10
md:h-8
md:w-8
      flex
      items-center
      justify-center
		rounded-md
     

      hover:bg-[#E8604A]
      transition-all
      duration-300
    "
              >
                <img
                  src={linkedin}
                  alt="LinkedIn"
                  className="w-6
h-6
sm:w-10
sm:h-10"
                />
              </a>
            </div>
          </div>

          {/* LINKS */}
          <div
            className="
             flex
gap-8
sm:gap-28
lg:gap-24
md:gap-80
mt-10
lg:mt-0

mx-auto
lg:mx-0
lg:mr-20
            "
          >
            <div>
              <h3
                className="text-white text-[14px]
sm:text-[20px] font-jakarta font-semibold"
              >
                Links
              </h3>

              <div
                className="
    mt-3
    sm:mt-5

    space-y-1
    sm:space-y-3

    text-[#D6D6D6]

    text-[11px]
    sm:text-[16px]
  "
              >
                <p>About Us</p>
                <p>FAQ's</p>
                <p>Why Choose Us?</p>
                <p>Services</p>
              </div>
            </div>

            <div>
              <h3
                className="text-white text-[14px]
sm:text-[20px] font-jakarta font-semibold"
              >
                Other Links
              </h3>

              <div
                className="mt-5 space-y-3  text-[11px]
    sm:text-[16px] text-[#D6D6D6]"
              >
                <p>Privacy Policy</p>
                <p>Term & Conditions</p>
              </div>
            </div>
          </div>
        </div>
        {/* RAPID OUTREACH TAGS */}
        <div
          className="
    absolute
    inset-0
    z-20
  "
        >
          {tags.map((tag, index) => (
            <motion.div
              key={index}
              initial={{
                y: -180,
                opacity: 0,
                rotate: tag.rotate,
                scale: 0.4,
              }}
              whileInView={{
                y: 0,
                opacity: 1,
                rotate: tag.rotate,
                scale: 1,
              }}
     whileHover={{
  scale: 1.20,
}}
          viewport={{ once: true }}
            transition={{
  delay: index * 0.1,
  duration: 1.9,
  type: "spring",
  bounce: 0.55,
  whileHover: {
    duration: 0.25,
  },
}}
              style={{
                left: tag.left,
                bottom: tag.bottom,
              }}
              className={`
  absolute

  bg-[#c7c7c7]
  text-[#1E1E1E]
pointer-events-auto
cursor-pointer
  font-jakarta
  font-semibold
  border
  border-black
  whitespace-nowrap
  shadow-black
  shadow-md

  px-1
  py-1

  lg:px-4
  lg:py-1.5
  md:px-2
  md:py-1

  text-[4px]
  md:text-[8px]
  lg:text-[11px]

  rounded-full

  shadow-[0_6px_20px_rgba(0,0,0,0.25)]

  ${tag.hideOnMobile ? "hidden sm:block" : ""}
`}
            >
              {tag.text}
            </motion.div>
          ))}
        </div>

        {/* BOTTOM WATERMARK */}
        <div
          className="
    absolute

    left-1/2
    -translate-x-1/2

   bottom-[10px]
lg:bottom-[15px]

    whitespace-nowrap

    font-unbounded
    font-bold

 text-[20px]

md:text-[60px]
lg:text-[110px]

    leading-none

    text-white/[0.06]

    select-none
    pointer-events-none

    z-10
  "
        >
          CRAFT YOUR AGENT
        </div>
      </div>

      {/* Floating AI Logo */}
      <div
        className="
    absolute
    left-[50%]
-translate-x-1/2
		  
bottom-[-20px]

    -translate-x-1/2

    z-[999]
    pointer-events-none
  "
      >
        <div
          className="
      overflow-hidden

    w-[140px]
h-[75px]

md:w-[370px]
md:h-[160px]

lg:w-[520px]
lg:h-[220px]
    "
        >
          <div
            className="
        w-[140px]
        h-[170px]

        md:w-[360px]
        md:h-[380px]

        lg:w-[520px]
        lg:h-[520px]

        rounded-full
        overflow-hidden
      "
          >
            <video
              autoPlay
              muted
              loop
              playsInline
              className="
          w-full
          h-full
          object-cover

          scale-[2.2]
        "
            >
              <source src={logoVideo} type="video/mp4" />
            </video>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
